import { AddRequest } from '../models/IAddRequest';
import { Agreement } from '../models/IAgreement';
import { Generation } from '../models/IGeneration';
import { LinkSend } from '../models/ILinkSend';
import { OrderStatus } from '../models/IOrderStatus';
import { OtpCheck } from '../models/IOtpCheck';
import { OtpSend } from '../models/IOtpSend';
import { UploadFile } from '../models/IUploadFile';
import { OrderStatuses } from '../models/OrderStatuses';
import { LogResult } from '../models/ILogResult';
import store from './store';
import { ApiUrls } from './textValues';
import { FlowResult, FlowStatus } from '../models/FlowStatus';
import { AbortResult } from '../models/IAbortResult';
import { FlowMoments, FlowSteps } from '../models/FlowSteps';
import { TranslationValues } from '../models/ITranslationValues';
import { Citizenship } from '../models/ICitizenship';
import { StateResult } from '../models/IStateResult';
import { IdentityDocument } from '../models/IIdentityDocument';
import { LoggerService } from './LoggerService';
export class ApiCall {
  public static instance: ApiCall;
  public static getInstance(): ApiCall {
    if (!ApiCall.instance) {
      ApiCall.instance = new ApiCall();
    }

    return ApiCall.instance;
  }

  private urls: ApiUrls;
  private serviceErrors = ['Service Unavailable', 'Unauthorized'];
  constructor() {
    this.urls = new ApiUrls();
  }

  // private async http2<T>(method: string, url: string, data: string): Promise<T> {
  //   return new Promise((resolve, reject) => {
  //     var xhr = new XMLHttpRequest();
  //     xhr.open(method, url);
  //     xhr.onload = function () {
  //       if (xhr.status >= 200 && xhr.status < 300) {
  //         resolve(xhr.response);
  //       } else {
  //         reject({
  //           status: xhr.status,
  //           statusText: xhr.statusText,
  //         });
  //       }
  //     };
  //     xhr.onerror = function () {
  //       reject({
  //         status: xhr.status,
  //         statusText: xhr.statusText,
  //       });
  //     };
  //     xhr.send(data);
  //   });
  // }

  private async http<T>(request: RequestInfo): Promise<T> {
    const response = await fetch(request);

    if (!response.ok) {
      let text = await response.text();
      throw new Error(text ?? response.statusText);
    }

    try {
      // may error if there is no body
      return await response.json();
    } catch (ex) {
      throw new Error('No json found in response ' + ex);
    }
  }

  private async post<T>(url: string, data: string, withRetry: boolean = true) {
    var requestUrl = new URL(url, store.apiBaseUrl);
    var request = new Request(requestUrl, {
      method: 'POST',
      body: data,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'IDKYC-TOKEN ' + store.token,
        'X-Request-Id': store.requestId,
      },
    });

    try {
      return await this.http<T>(request);
    } catch (ex) {
      if (!withRetry || this.serviceErrors.includes(ex.message)) {
        throw ex;
      }
      this.AddLog('Error in post ', ex);
      try {
        var request2 = new Request(requestUrl, {
          method: 'POST',
          body: data,
          headers: {
            'Content-Type': 'application/json',
            'Authorization': 'IDKYC-TOKEN ' + store.token,
            'X-Request-Id': store.requestId,
          },
        });
        return await this.http<T>(request2);
      } catch (ex2) {
        this.AddLog('Error in post ', ex2);
        var request3 = new Request(requestUrl, {
          method: 'POST',
          body: data,
          headers: {
            'Content-Type': 'application/json',
            'Authorization': 'IDKYC-TOKEN ' + store.token,
            'X-Request-Id': store.requestId,
          },
        });
        return await this.http<T>(request3);
      }
    }
  }

  private async get<T>(url: string, withRetry: boolean = true) {
    var requestUrl = new URL(url, store.apiBaseUrl);
    var request = new Request(requestUrl, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'IDKYC-TOKEN ' + store.token,
        'X-Request-Id': store.requestId,
      },
    });
    try {
      return await this.http<T>(request);
    } catch (ex) {
      if (!withRetry || this.serviceErrors.includes(ex.message)) {
        throw ex;
      }
      this.AddLog('Error in get ', ex);
      try {
        var request2 = new Request(requestUrl, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': 'IDKYC-TOKEN ' + store.token,
            'X-Request-Id': store.requestId,
          },
        });
        return await this.http<T>(request2);
      } catch (ex2) {
        this.AddLog('Error in get ', ex2);
        var request3 = new Request(requestUrl, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': 'IDKYC-TOKEN ' + store.token,
            'X-Request-Id': store.requestId,
          },
        });
        return await this.http<T>(request3);
      }
    }
  }

  public async SendOTPCode(requestId: string, phoneNumber: string): Promise<OtpSend> {
    let data = { requestId: requestId, phone: phoneNumber };
    let jsonResp = await this.post<OtpSend>(this.urls.OtpSend, JSON.stringify(data));
    return jsonResp;
  }

  public async CheckOTPCode(requestId: string, otpCode: string): Promise<OtpCheck> {
    let data = { requestId: requestId, otp: otpCode };
    let jsonResp = await this.post<OtpCheck>(this.urls.OtpCheck, JSON.stringify(data));
    return jsonResp;
  }

  public async AddIdentificationRequest(version: string): Promise<boolean | Error> {
    LoggerService.log('Calling identity request with store:' + JSON.stringify(store));
    let data = {
      requestId: store.requestId,
      clientDeviceInfo: JSON.stringify({ device: store.device, sensors: store.sensors }),
      redirectId: store.redirectId,
      phoneNumber: store.phoneNumber,
      version: version,
      demoMode: store.environment == 'DEMO',
    };
    let jsonResp = await this.post<AddRequest>(this.urls.IdentityInsert, JSON.stringify(data));
    if (store.requestId == '') {
      store.requestId = jsonResp.requestId;
    }
    store.phoneNumber = jsonResp.phoneNumber;
    store.flowStatus = FlowStatus[jsonResp.state];
    store.logSteps = jsonResp.logSteps;
    store.hasTilt = jsonResp.hasIdTilt;
    store.debug = jsonResp.debug;
    store.idModelsPath = jsonResp.idModelsPath;
    store.faceModelsPath = jsonResp.faceModelsPath;
    store.citizenship = jsonResp.citizenship;
    store.initialized = true;
    store.videoRecording = jsonResp.videoRecording;
    store.glareTreshold = jsonResp.glareTreshold;
    store.blurTreshold = jsonResp.blurTreshold;
    store.manualCaptureTimeout = jsonResp.manualCaptureTimeout;
    store.redirectBaseUrl = jsonResp.redirectUrl;
    store.detectedCountryCode = jsonResp.detectedCountryCode || '';
    return true;
  }

  public async UploadFileForRequestB64(requestId: string, type: string, b64Data: string): Promise<UploadFile> {
    let data = {
      requestId: requestId,
      type: type,
      data: b64Data,
      idDetectionType: store.idType,
      manualCapture: store.manualCaptureEnabled,
    };
    let respJson = await this.post<UploadFile>(this.urls.UploadCapture, JSON.stringify(data));
    LoggerService.log(`apicall | uploadfileforrequestb64 | ${respJson}`);
    return respJson;
  }

  public async GetAgreement(agreementType: string): Promise<string> {
    let resp = await this.get<Agreement>(this.urls.GetAgreement + '?type=' + agreementType + '&requestId=' + store.requestId);
    return resp.htmlText;
  }

  public async GenerateAgreement(agreementType: string): Promise<boolean> {
    let data = { requestId: store.requestId, documentType: agreementType };
    let resp = await this.post<Generation>(this.urls.GenerateAgreement, JSON.stringify(data));
    return resp.generation;
  }

  public async GetStatus(requestId: string): Promise<OrderStatuses> {
    let resp = await this.get<OrderStatus>(this.urls.GetStatus + '?orderId=' + requestId);
    return OrderStatuses[resp.status];
  }

  public async GetStatusUi(requestId: string): Promise<FlowStatus | null> {
    let resp = await this.get<OrderStatus>(this.urls.GetStatusUi + '?orderId=' + requestId);
    if (resp.status == 'NOTFOUND') return null;
    return FlowStatus[resp.status];
  }

  public async SendLink(link: string, phoneNumber: string): Promise<boolean> {
    let data = { requestId: store.requestId, link: link, phoneNumber: phoneNumber };
    let resp = await this.post<LinkSend>(this.urls.SendLink, JSON.stringify(data));
    return resp.sent;
  }

  public async GetCitizenshipList(): Promise<Citizenship[]> {
    let resp = await this.get<Citizenship[]>(this.urls.CitizenshipList);
    return resp;
  }

  public async GetIdList(): Promise<IdentityDocument[]> {
    let resp = await this.get<IdentityDocument[]>(this.urls.IdList + '?citizenship=' + store.citizenship);
    return resp;
  }

  public async SetCitizenship(): Promise<boolean> {
    var setCitReq = { requestId: store.requestId, citizenship: store.citizenship };
    var result = await this.post<StateResult>(this.urls.SetCitizenship, JSON.stringify(setCitReq));
    store.flowStatus = FlowStatus[result.state];
    return true;
  }

  public async SetIdentityDocument(): Promise<boolean> {
    var setIdReq = { requestId: store.requestId, identityDocument: store.idDocument };
    var result = await this.post<StateResult>(this.urls.SetId, JSON.stringify(setIdReq));
    store.flowStatus = FlowStatus[result.state];
    return true;
  }

  public async SetTwoSidedId(): Promise<boolean> {
    try {
      let result = await this.post<StateResult>(this.urls.SetTwoSidedId + '?orderId=' + store.requestId, JSON.stringify({}), false);
      store.flowStatus = FlowStatus[result.state];
      return true;
    } catch {}
  }

  public async CheckValidity(): Promise<boolean> {
    var result = await this.get<UploadFile>(this.urls.CheckValidity + '?orderId=' + store.requestId);
    store.flowStatus = FlowStatus[result.state];
    return true;
  }

  public async AddLog(error: any, context: any): Promise<boolean> {
    if (!store.debug) return false;
    try {
      let data = {
        requestId: store.requestId,
        action: FlowStatus[store.flowStatus],
        message: JSON.stringify({ error, context }),
      };
      let result = await this.post<LogResult>(this.urls.AddLog, JSON.stringify(data), false);
      return result.saved;
    } catch {}
  }

  public async AddStep(step: FlowSteps, moment: FlowMoments): Promise<boolean> {
    if (store.logSteps == false) return;
    let data = { requestId: store.requestId, redirectId: store.redirectId, step: FlowSteps[step], moment: FlowMoments[moment], timestamp: new Date().toISOString() };
    let result = await this.post<LogResult>(this.urls.AddStep, JSON.stringify(data));
    return result.saved;
  }

  public async AbortRequest(): Promise<AbortResult> {
    let result = await this.post<AbortResult>(this.urls.AbortRequest, JSON.stringify({ requestId: store.requestId }));
    return result;
  }

  public async GetTranslations(langIso: string): Promise<TranslationValues> {
    let result = await this.get<TranslationValues>(this.urls.Translations + '?langIso=' + langIso);
    return result;
  }

  public async LandingValidationStartFlow(cameraIsAccessible: boolean): Promise<FlowStatus> {
    let result = await this.post<FlowResult>(this.urls.StartFlow, JSON.stringify({ requestId: store.requestId, cameraIsAccessible: cameraIsAccessible }));
    return FlowStatus[result.state];
  }

  public async GetNextFlowState(): Promise<FlowStatus> {
    let result = await this.get<FlowResult>(this.urls.NextFlowState + '?requestId=' + store.requestId);
    return FlowStatus[result.state];
  }

  public async GetFlowState(): Promise<FlowStatus> {
    let result = await this.get<FlowResult>(this.urls.CurrentFlowState + '?requestId=' + store.requestId, false);
    return FlowStatus[result.state];
  }

  public async GetNextStateForCaptureError(): Promise<FlowStatus> {
    let result = await this.get<FlowResult>(this.urls.NextStateForCaptureError + '?requestId=' + store.requestId);
    return FlowStatus[result.state];
  }
}
